import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { Button } from "./Button.js";
const SaveButton = memo(forwardRef(({
  distinction,
  flow,
  isDirty,
  isPrimary = true,
  labelSave,
  labelSaved,
  scheme,
  size,
  ...rest
}, ref) => /* @__PURE__ */ jsx(
  Button,
  {
    ref,
    componentClassName: ["button", "save-button"],
    className: [rest.className],
    distinction: isPrimary ? "primary" : distinction,
    flow,
    scheme,
    size,
    ...rest,
    children: isDirty ? labelSave ?? "Save" : labelSaved ?? "Save"
  }
)));
SaveButton.displayName = "SaveButton";
export {
  SaveButton
};
//# sourceMappingURL=SaveButton.js.map
